import styled, { css } from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/units';
import Modal from '#/components/Modal';
import { HeadedModalProps } from './HeadedModal';
import { MODAL_THEMES } from './config';

const withHeaderTheme = ({
  theme = 'default',
}: Pick<HeadedModalProps, 'theme'>) => {
  return css`
    background-color: ${MODAL_THEMES[theme].headerBgColor};
    border-bottom: ${MODAL_THEMES[theme].border};
  `;
};

const withFooterTheme = ({
  theme = 'default',
}: Pick<HeadedModalProps, 'theme'>) => {
  return css`
    background-color: ${MODAL_THEMES[theme].footerBgColor};
    border-top: ${MODAL_THEMES[theme].border};
  `;
};

export const StyledModal = styled(Modal)<HeadedModalProps>`
  .modal-content {
    background-color: ${(props: HeadedModalProps) =>
      MODAL_THEMES[props.theme || 'default'].bgColor};
  }
`;

export const TopRightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;

export const HeaderContainer = styled.div<{
  theme?: HeadedModalProps['theme'];
}>`
  ${withHeaderTheme}
  padding: 1rem;
  width: 100%;
  border-radius: 10px 10px 0 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: 70px;
    border-radius: 0;
  }
`;

export const ModalHeaderTitle = styled.h1<
  Pick<HeadedModalProps, 'titlePlacement'>
>`
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: bold;
  text-align: ${(props) => props.titlePlacement ?? 'center'};
  margin: 0;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-weight: normal;
  }
`;

export const ModalHeaderInfo = styled.div`
  p {
    color: white;
    font-size: 0.7rem;
    margin-bottom: 0;
    line-height: 1rem;
  }
`;

export const FooterContainer = styled.div<HeadedModalProps>`
  display: flex;
  justify-content: end;
  column-gap: 1rem;
  align-items: center;
  padding: 1rem;

  ${withFooterTheme}
`;
